export default "__VITE_ASSET__DFcAPsXm__"